import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Output, ViewChild, ViewChildren, QueryList, Input, OnDestroy, AfterViewInit, ElementRef, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import Fingerprint2 from 'fingerprintjs2';
import { AuthenticateserviceService } from 'src/app/_service/authenticateservice.service';
import { Country, CountryService } from 'src/app/_service/country.service';
import { CustomControlsService } from 'src/app/_service/custom-controls.service';
import { DeviceService } from 'src/app/_service/tv-detect.service';
import { TVNavigationService } from 'src/app/_service/tv-navigation.service';
import { TvBackButtonService, OverlayType } from 'src/app/_service/tv-back-button.service';
import { WhiteLabelService } from 'src/app/_service/white-label.service';
import { URLS } from 'src/app/constants/URLS';
import { countryPhoneCodes } from 'src/app/constants/phoneInternalization';
import { getDeviceType } from 'src/app/utils/device.utils';
import { environment } from 'src/environments/environment';
import { GuestTokenService } from 'src/app/_service/guest-token.service';

declare const firebase: any;

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit, OnDestroy {

  selectedCountry: string = 'IN';
  deviceId: string;
  guestExpired: boolean = false;
  @Input() isLoading:boolean = false;
  showCountrySelection:boolean = true;
  authType:string = 'PHONE';
  authMethods: any[] = [];
  countrySearch: string = '';
  isCountryModalOpen: boolean = false;
  requestId;
  qrCodeUrl:string = '';
  countdown = 120;
  intervalRef: any;
  countriesList: Country[] = [];
  isQrCreating = false;
  isQrPolling  = false;
  isQrExchanging = false;
  qrPollInterval: any;
  marqueCountdown: string = '';
  showMarquee: boolean = true;
  launchDate = new Date('2026-03-01T00:00:00');
  days = '00';
  hours = '00';
  minutes = '00';
  seconds = '00';
  private timerId: any;
  @ViewChild('marqueeContent', { static: false }) marqueeContent!: ElementRef<HTMLDivElement>;

  // TV QR panel navigation
  @ViewChildren('qrActionBtn') qrActionBtns: QueryList<ElementRef>;
  qrFocused = false;
  private qrRegionId = 'qr-panel-region';
  private tvSubs: Subscription[] = [];

isDragging = false;
startX = 0;
lastTranslateX = 0;
currentTranslateX = 0;
channelIdCache = '';
channelUrl: string = URLS.channelUrl;
private wlSub: Subscription;

  constructor(
    private http:HttpClient,
    private device: DeviceService,
    private countryService: CountryService,
    private toastrService: CustomControlsService,
    private authService: AuthenticateserviceService,
    private router: Router,
    private renderer: Renderer2,
    private tvNav: TVNavigationService,
    private tvBackButton: TvBackButtonService,
    public wlService: WhiteLabelService,
    private guestTokenService: GuestTokenService
  )
  {
    // firebase.initializeApp({
    //   apiKey: "AIzaSyA1Xl6t7H0F-niShxXFCBFAAT-8l_v6zq0",
    //   authDomain: "toqqer-app-dev-e5f3e.firebaseapp.com",
    //   projectId: "toqqer-app-dev-e5f3e",
    //   messagingSenderId: "470163066954",
    //   appId: "1:470163066954:web:5642c6aa16311e47ba56b3"
    // });
    // firebase.messaging();
    const existingDeviceId = localStorage.getItem('deviceId');
    // Reuse a real fingerprint id (32-char hex); regenerate if missing or a
    // legacy throwaway id, so OTP binds the stable device id, not a throwaway.
    if(existingDeviceId && /^[a-f0-9]{32}$/i.test(existingDeviceId)){
      this.deviceId = existingDeviceId;
    }else{
      this.generateFingerprint();
    }
  }
  
  ngOnInit() {
    const urlTree = this.router.parseUrl(this.router.url);
    this.guestExpired = urlTree.queryParams['guestExpired'] === 'true';
    this.countriesList = this.countryService.getCountries();
    this.marqueStartCountdown();
    this.wlSub = this.wlService.channelId$.subscribe(id => {
      this.channelIdCache = id || '';
      this.getUserCountry();
    });
  }

  ngAfterViewInit() {
    if (!this.isTV) return;

    setTimeout(() => {
      this.registerQrRegion();
      this.tvNav.activateRegion(this.qrRegionId,0);

      // Re-register when QR button swaps (Generate ↔ Refresh via *ngIf).
      // qrActionBtns.changes fires multiple times during Generate QR — once
      // when the button is removed (loading state), once when "Refresh QR"
      // appears. Between calls, unregisterRegion's microtask + auth-form
      // re-registrations from change-detection compete for focus. So we both
      // (a) only activate when the QR region actually has buttons after the
      // re-register, and (b) defensively re-activate after a longer delay to
      // outlast any later focus-stealing CD side effects.
      this.qrActionBtns.changes.subscribe(() => {
        setTimeout(() => {
          this.registerQrRegion();
          if (this.qrActionBtns.length > 0) {
            this.tvNav.activateRegion(this.qrRegionId, 0);
            // Defensive re-activate after CD-side effects have settled.
            setTimeout(() => {
              if (this.qrActionBtns.length > 0) {
                this.tvNav.activateRegion(this.qrRegionId, 0);
              }
            }, 300);
          }
        }, 50);
      });

      // Cross-panel navigation: auth-form ←→ qr-panel
      let lastAuthFocusIndex = 0;
      this.tvSubs.push(
        this.tvNav.boundary$.subscribe(event => {
          if (event.regionId === 'auth-form-region' && event.direction === 'left') {
            lastAuthFocusIndex = this.tvNav.getFocusedIndex();
            this.tvNav.activateRegion(this.qrRegionId, 0);
          } else if (event.regionId === this.qrRegionId && event.direction === 'right') {
            this.tvNav.activateRegion('auth-form-region', lastAuthFocusIndex);
          }
        })
      );

      // Track QR button focus state for [class.tv-focus] binding
      this.tvSubs.push(
        this.tvNav.focus$.subscribe(focusKey => {
          this.qrFocused = !!focusKey && focusKey.startsWith(this.qrRegionId + ':');
        })
      );
    }, 200);
  }

  private registerQrRegion(): void {
    this.tvNav.unregisterRegion(this.qrRegionId);
    const btns = this.qrActionBtns.toArray();
    if (btns.length > 0) {
      this.tvNav.registerRegion({
        id: this.qrRegionId,
        type: 'form',
        elementRef: btns[0],
        focusableItems: btns
      });
    }
  }

  marqueStartCountdown() {
    const launchDate = new Date('2026-03-31T00:00:00');
    this.timerId = setInterval(() => {
      const now = new Date();
      const diff = launchDate.getTime() - now.getTime();
      if (diff <= 0) {
        this.showMarquee = false;
        clearInterval(this.timerId);
        return;
      }
      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      const m = Math.floor((diff / (1000 * 60)) % 60);
      const s = Math.floor((diff / 1000) % 60);
      this.days = String(d).padStart(2, '0');
      this.hours = String(h).padStart(2, '0');
      this.minutes = String(m).padStart(2, '0');
      this.seconds = String(s).padStart(2, '0');
    }, 1000);
  }

  getSelectedCountryData() {
    return this.countriesList.find(c => c.code === this.selectedCountry);
  }

  get isTV(): boolean {
    return this.device.isTV();
  }

  get appName(): string {
    return this.wlService.isWhiteLabel()
      ? (localStorage.getItem('wl_channel') || '').replace(/^@/, '')
      : 'Toqqer';
  }    
  
  generateFingerprint(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      Fingerprint2.get((components) => {
        const values = components.map((component) => component.value);
        this.deviceId = Fingerprint2.x64hash128(values.join(''), 31);
        if(this.deviceId){
          localStorage.setItem('deviceId', this.deviceId);
        }
        resolve(this.deviceId);
      });
    });
  }

  handleCountryChange(step:number){
    this.showCountrySelection = (step === 1);
  }

  updateLoading(value: boolean) {
    this.isLoading = value;
    console.log('Loading state updated:', this.isLoading);
  }

  onCountryChange(event: any) {
    this.selectedCountry = event.target.value;
  }

  private countryRegionId = 'country-modal-region';
  private countryFocusIndex = 0; // 0=search, 1=close, 2+=country items
  private countryKeyHandler: ((e: KeyboardEvent) => void) | null = null;

  openCountrySelector() {
    this.isCountryModalOpen = true;
    if (this.isTV) {
      this.tvNav.suppressNavigation();
      this.tvBackButton.pushOverlay({
        id: 'country-modal',
        type: OverlayType.MODAL,
        onClose: () => this.closeCountrySelector()
      });
      setTimeout(() => this.setupCountryModalNavigation(), 150);
    }
  }

  closeCountrySelector() {
    this.isCountryModalOpen = false;
    if (this.isTV) {
      this.teardownCountryModalNavigation();
      this.tvBackButton.popOverlay('country-modal');
      this.tvNav.resumeNavigation();
      this.tvNav.activateRegion('auth-form-region', 0);
    }
  }

  selectCountry(code: string) {
    this.selectedCountry = code;
    this.closeCountrySelector();
  }

  /**
   * Custom D-pad navigation for country modal:
   * Layout: [Search bar] [Close btn]    ← header row (LEFT/RIGHT)
   *         [Country 1]                  ← DOWN/UP vertical list
   *         [Country 2]
   *         ...
   */
  private setupCountryModalNavigation(): void {
    this.countryFocusIndex = 0;
    this.updateCountryFocus();

    this.countryKeyHandler = (e: KeyboardEvent) => {
      const key = e.key;
      if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Enter', 'Escape', 'Backspace'].includes(key)) return;
      e.preventDefault();
      e.stopPropagation();

      const itemCount = document.querySelectorAll('.country-item').length;
      const totalItems = 2 + itemCount; // 0=search, 1=close, 2+=items

      switch (key) {
        case 'ArrowRight':
          if (this.countryFocusIndex === 0) {
            this.countryFocusIndex = 1; // search → close
            this.updateCountryFocus();
          }
          break;
        case 'ArrowLeft':
          if (this.countryFocusIndex === 1) {
            this.countryFocusIndex = 0; // close → search
            this.updateCountryFocus();
          }
          break;
        case 'ArrowDown':
          if (this.countryFocusIndex < totalItems - 1) {
            // From search(0) or close(1), jump to first country(2)
            if (this.countryFocusIndex <= 1) {
              this.countryFocusIndex = 2;
            } else {
              this.countryFocusIndex++;
            }
            this.updateCountryFocus();
          }
          break;
        case 'ArrowUp':
          if (this.countryFocusIndex > 0) {
            // From first country(2), jump back to search(0)
            if (this.countryFocusIndex === 2) {
              this.countryFocusIndex = 0;
            } else if (this.countryFocusIndex > 2) {
              this.countryFocusIndex--;
            }
            this.updateCountryFocus();
          }
          break;
        case 'Enter':
          this.activateCountryFocusItem();
          break;
        case 'Escape':
        case 'Backspace':
          this.closeCountrySelector();
          break;
      }
    };

    document.addEventListener('keydown', this.countryKeyHandler, true);
  }

  private teardownCountryModalNavigation(): void {
    if (this.countryKeyHandler) {
      document.removeEventListener('keydown', this.countryKeyHandler, true);
      this.countryKeyHandler = null;
    }
  }

  private updateCountryFocus(): void {
    // Clear all focus
    document.querySelector('.country-modal .search-box')?.classList.remove('tv-focus');
    document.querySelector('.country-modal .close-btn')?.classList.remove('tv-focus');
    document.querySelectorAll('.country-item').forEach(el => el.classList.remove('tv-focus'));

    // Apply focus
    if (this.countryFocusIndex === 0) {
      document.querySelector('.country-modal .search-box')?.classList.add('tv-focus');
    } else if (this.countryFocusIndex === 1) {
      document.querySelector('.country-modal .close-btn')?.classList.add('tv-focus');
    } else {
      const items = document.querySelectorAll('.country-item');
      const itemIdx = this.countryFocusIndex - 2;
      if (items[itemIdx]) {
        items[itemIdx].classList.add('tv-focus');
        items[itemIdx].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }
    }
  }

  private activateCountryFocusItem(): void {
    if (this.countryFocusIndex === 0) {
      // Search bar — open keyboard for typing
      const searchBox = document.querySelector('.country-modal .search-box') as HTMLInputElement;
      if (searchBox) searchBox.focus();
    } else if (this.countryFocusIndex === 1) {
      // Close button
      this.closeCountrySelector();
    } else {
      // Country item — click it
      const items = document.querySelectorAll('.country-item');
      const itemIdx = this.countryFocusIndex - 2;
      if (items[itemIdx]) (items[itemIdx] as HTMLElement).click();
    }
  }

  get filteredCountries() {
    return countryPhoneCodes.filter(c =>
      c.name.toLowerCase().includes(this.countrySearch.toLowerCase())
    );
  }

  getUserCountry(){
    this.isLoading = true;
    const channelId = this.channelIdCache || '1';
    this.http.get(`${URLS.authMethod}?channelId=${channelId}`,{}).subscribe((result:any)=>{
      console.log(result);
      this.isLoading = false;
      // this.authType = (result.data.authType).toUpperCase();
      console.log(this.authType);
      const matchedCountry = this.countriesList.find(
        country => country.name.toLowerCase() === result.country.toLowerCase()
      );
      this.selectedCountry = matchedCountry?.code || 'IN';
      if (result.methods && Array.isArray(result.methods)) {
        this.authMethods = result.methods;
      }
    },(error)=>{
      this.isLoading = false;
      this.selectedCountry = 'INDIA';
      this.authType = 'PHONE';
      this.authMethods = [];
    })
  }
  
  async createQrSession() {
    const deviceType = getDeviceType();
    try {
      this.isQrCreating = true;
      const url = `${environment.TQR_SERVICE}toqqer/services/addSlaveDevice`;
      const res: any = await this.http.post(`${url}?device_config=slave&device_id=${this.deviceId}&device_name=2312BPC51H&device_type=${deviceType}`,{}).toPromise();
      this.requestId = res?.request_id;
      this.qrCodeUrl = JSON.stringify({ request_id: this.requestId });
      this.isQrCreating = false;
      this.startQrPolling();
    } catch (err) {
      console.error(err);
      this.isQrCreating = false;
      this.qrCodeUrl = '';
    }
  }

  startQrPolling() {
    this.stopQrPolling();
    this.isQrPolling = true;
    const formData = new FormData();
    formData.append('requestId', this.requestId);
    this.qrPollInterval = setInterval(() => {
      this.http.post<any>(`${environment.TQR_SERVICE}masterSlaveController/getSlaveTokenService`,formData).subscribe(res => {
        if (res.status === 'SUCCESS') {
          this.stopQrPolling();
          this.isQrExchanging = true;
          this.exchangeQrToken(res.refreshToken);
          localStorage.setItem('refreshToken', res.idToken);
        }  
        if (res.status === 'EXPIRED') {
          this.stopQrPolling();
          this.qrCodeUrl = '';
          this.isQrPolling = false;
        }
      });
    }, 3000);
  }
  
  stopQrPolling() {
    if (this.qrPollInterval) {
      clearInterval(this.qrPollInterval);
      this.qrPollInterval = null;
    }
    this.isQrPolling = false;
  }

  exchangeQrToken(idToken: string) {
    this.isQrExchanging = true;
    this.authService.toqqerUserLogin(idToken).subscribe(
      (userDetails: any) => {
        this.isQrExchanging = false;
        this.guestTokenService.clearGuestState();
        localStorage.setItem('token', userDetails.refreshToken);
        this.authService.isAuthenticatedSubject.next(true);
        localStorage.setItem('screenName', userDetails.data.screenName);
        localStorage.setItem('userName', userDetails.data.userName);
        localStorage.setItem('userId', userDetails.data.localUserId);
        localStorage.setItem('profileImage', userDetails.data.profileImage);
        localStorage.setItem('description', userDetails.data.description);
        localStorage.setItem('contact', userDetails.data.phoneNumber);
        localStorage.setItem('appDarkMode', 'true');
        const redirectUrl = localStorage.getItem('redirectAfterLogin');
        localStorage.removeItem('redirectAfterLogin');
        if (redirectUrl && !redirectUrl.startsWith('/login')) {
          this.router.navigateByUrl(redirectUrl, { replaceUrl: true });
        } else {
          const wlChannel = localStorage.getItem('wl_channel');
          const defaultRoute = wlChannel ? `/${wlChannel}/v` : '/v';
          this.router.navigate([defaultRoute], { replaceUrl: true });
        }
        this.showSuccess(`Welcome! 🖐️ ${userDetails.data.screenName}`);
      },
      () => {
        this.isQrExchanging = false;
        this.qrCodeUrl = '';
      }
    );
  }

  async getFbToken() {
    try {
      console.log("Waiting for service worker...");
      const registration = await navigator.serviceWorker.ready;
      console.log("Requesting notification permission...");
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        console.warn("Notification permission not granted");
        return "";
      }
      const messaging = firebase.messaging();
      console.log("📨 Generating FCM Token...");
      const token = await messaging.getToken({
        vapidKey:"BAwu9RxatZp9D8_2ZYugY3AnjKsoyGVMXnmpA1lOgFGrrp6jOoEW_K6RlXb4TiCKL_CXlG78gVGs6I0eDG2bGCM",
        serviceWorkerRegistration: registration,
      });
      console.log("FB Token:", token);
      return token;
    } catch (err) {
      console.error("Error generating FCM token:", err);
      return "";
    }
  }

  generateQr() {
    this.qrCodeUrl = '';
    this.isQrCreating = true;
    this.isQrPolling = false;
    this.createQrSession();
    this.startCountdown();
  }
  
  startCountdown() {
    clearInterval(this.intervalRef);
    this.countdown = 120;
    this.intervalRef = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.onQrExpired();
      }
    }, 1000);
  }

  onQrExpired() {
    clearInterval(this.intervalRef);
    this.intervalRef = null;
    this.stopQrPolling();   
    this.qrCodeUrl = '';
    this.requestId = null;
    this.isQrCreating = false;
    this.isQrPolling = false;
    this.isQrExchanging = false;
    console.log('QR expired, polling stopped');
  }
  
  showSuccess(message: string): void {
    this.toastrService.showNotification('success', '', message, 4000);
  }

  ngOnDestroy() {
    clearInterval(this.intervalRef);
    this.stopQrPolling();
    if (this.timerId) clearInterval(this.timerId);
    this.tvSubs.forEach(s => s.unsubscribe());
    if (this.wlSub) this.wlSub.unsubscribe();
    if (this.isTV) {
      this.tvNav.unregisterRegion(this.qrRegionId);
      this.teardownCountryModalNavigation();
    }
  }
}